"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STREAM_ALERT_PERSISTENT = exports.STREAM_ALERT_EPHEMERAL = void 0;
var STREAM_ALERT_PERSISTENT = exports.STREAM_ALERT_PERSISTENT = 'PERSISTENT';
var STREAM_ALERT_EPHEMERAL = exports.STREAM_ALERT_EPHEMERAL = 'EPHEMERAL';